/** Catalog service pkey for a contract line (work order / layaway entry). */
export function catalogServiceId(entry) {
	if (entry?.type !== 'service') {
		return null;
	}
	return entry.inventory ?? entry.service ?? entry.pkey;
}

export function findServiceEntryIndex(entries, serviceKey) {
	const key = String(serviceKey);
	return (entries || []).findIndex(
		(entry) => entry?.type === 'service' && String(catalogServiceId(entry)) === key
	);
}

export function existingCatalogServiceIds(entries) {
	return (entries || [])
		.filter((entry) => entry?.type === 'service')
		.map((entry) => catalogServiceId(entry))
		.filter((id) => id != null && id !== '');
}
